"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _AppProvider = _interopRequireDefault(require("../AppProvider/AppProvider.index"));

var _ResponsiveProvider = _interopRequireDefault(require("../ResponsiveProvider/ResponsiveProvider.index"));

var _ThemeProvider = require("./ThemeProvider.styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ThemeProvider = function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$globalStyles = _ref.globalStyles,
      globalStyles = _ref$globalStyles === void 0 ? '' : _ref$globalStyles,
      lcSettings = _ref.liveClickerSettings,
      _ref$root = _ref.root,
      root = _ref$root === void 0 ? true : _ref$root,
      theme = _ref.theme;
  var GlobalStyles = root ? (0, _ThemeProvider.getGlobalStyles)({
    globalStyles: globalStyles,
    theme: theme
  }) : _react.Fragment;

  var _useState = (0, _react.useState)(lcSettings),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
      liveClickerSettings = _useState2[0];

  return /*#__PURE__*/_react["default"].createElement(_AppProvider["default"], {
    liveClickerSettings: liveClickerSettings
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(GlobalStyles, null), /*#__PURE__*/_react["default"].createElement(_ResponsiveProvider["default"], null, children)));
};

ThemeProvider.defaultProps = {
  globalStyles: '',
  liveClickerSettings: undefined,
  root: true
};
ThemeProvider.propTypes = {
  children: _propTypes.node.isRequired,
  globalStyles: _propTypes.string,
  liveClickerSettings: (0, _propTypes.shape)({
    apiKey: _propTypes.string.isRequired,
    clientId: _propTypes.number.isRequired,
    componentId: _propTypes.number.isRequired,
    playerIdProduct: _propTypes.number.isRequired,
    playerIdConfigurator: _propTypes.number.isRequired,
    playerIdContent: _propTypes.number.isRequired
  }),
  root: _propTypes.bool,
  theme: (0, _propTypes.shape)({}).isRequired
};
ThemeProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ThemeProvider",
  "props": {
    "globalStyles": {
      "defaultValue": {
        "value": "''",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "root": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "liveClickerSettings": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "",
      "type": {
        "name": "shape",
        "value": {
          "apiKey": {
            "name": "string",
            "required": true
          },
          "clientId": {
            "name": "number",
            "required": true
          },
          "componentId": {
            "name": "number",
            "required": true
          },
          "playerIdProduct": {
            "name": "number",
            "required": true
          },
          "playerIdConfigurator": {
            "name": "number",
            "required": true
          },
          "playerIdContent": {
            "name": "number",
            "required": true
          }
        }
      },
      "required": false
    },
    "children": {
      "description": "",
      "type": {
        "name": "node"
      },
      "required": true
    },
    "theme": {
      "description": "",
      "type": {
        "name": "shape",
        "value": {}
      },
      "required": true
    }
  }
};
var _default = ThemeProvider;
exports["default"] = _default;